import { SxProps, Theme } from "@mui/material/styles";

const textSize = (theme: Theme) => theme.typography.body2.fontSize;
const iconSize = "1.25rem";
const buttonIconSize = "1rem";
const inputPaddingY = "0.25rem";

export const actionBarSxContentOnly: SxProps<Theme> = {
	"& > *": {
		maxHeight: "1.75rem",
	},
	"& .MuiInputBase-root": {
		fontSize: textSize,
		flex: 1,
		"& .MuiInputBase-input": {
			paddingY: inputPaddingY,
		},
	},
	"& .MuiPickersInputBase-root": {
		fontSize: textSize,
		flex: 1,
		"& .MuiPickersInputBase-sectionsContainer": {
			paddingY: inputPaddingY,
		},
	},
	"& .MuiInputLabel-root": {
		fontSize: textSize,
		"&:not(.MuiInputLabel-shrink)": {
			transform: `translate(12px, ${inputPaddingY}) scale(1)`,
		},
	},
	"& .MuiTextField-root, & .MuiPickersTextField-root": {
		maxWidth: 150,
	},
	"& .MuiAutocomplete-root": {
		display: "flex",
		"& > .MuiTextField-root": {
			flex: 1,
			maxWidth: "unset",
		},
		"& .MuiInputBase-root.MuiOutlinedInput-root": {
			paddingY: 0,
			"& .MuiInputBase-input": {
				paddingY: inputPaddingY,
				maxWidth: "20ch",
			},
		},
		"& .MuiAutocomplete-clearIndicator": {
			backgroundColor: (theme: Theme) => theme.palette.background.paper,
			"&:hover": {
				backgroundColor: (theme: Theme) => theme.palette.grey[200],
			},
		},
		"&.MuiAutocomplete-hasClearIcon.MuiAutocomplete-hasPopupIcon": {
			"& .MuiInputBase-root.MuiOutlinedInput-root": {
				paddingRight: "2rem",
			},
		},
		"& .MuiCircularProgress-root": {
			position: "absolute",
			right: "2.5rem",
		},
		"& .MuiAutocomplete-tag": {
			height: "1rem",
			"& .MuiChip-deleteIcon": {
				fontSize: "1rem",
			},
		},
	},
	"& .AavoNativeSelectRoot": {
		maxHeight: "2rem",
	},
	"& .MuiButton-root": {
		paddingY: inputPaddingY,
		minHeight: "1.75rem",
		"& .MuiTypography-root": {
			fontSize: "0.75rem",
			lineHeight: textSize,
		},
		"& .MuiButton-startIcon": {
			"& > svg": {
				fontSize: buttonIconSize,
			},
		},
	},
	"& .MuiIconButton-root": {
		fontSize: iconSize,
		paddingX: "0.375rem",
		paddingY: "0.25rem",
	},
	"& .AavoCheckbox-container": {
		justifyContent: "center",
		"& .MuiFormControlLabel-root": {},
		"& .MuiCheckbox-root": {
			padding: "0.25rem",
			"& svg": {
				fontSize: iconSize,
			},
		},
		"& .MuiFormControlLabel-label": {
			fontSize: textSize,
		},
	},
};
